<div class="filter-dialog">
	<div class="bg info"></div>
	<p>Redil intentará arreglar las alertas de los ordeños automáticamente.</p>
	<p>
		AVISO: Es un proceso lento y por ello se recomienda hacerlo con filtros, por ejemplo seleccionando por
		tipo de alerta.
	</p>

	<button class="app-btn tertiary" (click)="closeDialog('filters')">
		<span class="italics">Continuar con filtros actuales </span>
	</button>
	<button class="app-btn tertiary" (click)="closeDialog('all')">
		<span class="italics">Continuar sin filtros</span>
	</button>
	<button class="app-btn optional" (click)="closeDialog(null)">Cancelar</button>
</div>
